import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "../features/auth/authSlice";
import { authServiceApi } from "./authServiceApi";
import { invalidateAllTagsOnSignInMiddleware } from "./middleware/middleware";
import { paymentServiceApi } from "./paymentServiceApi";

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    [authServiceApi.reducerPath]: authServiceApi.reducer,
    [paymentServiceApi.reducerPath]: paymentServiceApi.reducer,
    auth: authReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authServiceApi.middleware)
      .concat(paymentServiceApi.middleware)
      .concat(
        invalidateAllTagsOnSignInMiddleware([
          authServiceApi,
          paymentServiceApi,
        ]),
      ),
});

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
